import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {StateSearchModel} from "../state-search.model";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-state-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(StateSearchModel),
        registerSearchControl(StateMultiSelectSearchControlComponent)
    ]
})
export class StateMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<StateSearchModel> {
    constructor(model: StateSearchModel, injector: Injector) {
        super(model, injector, "state", "name");
    }
}
